import React from "react";
import "../css/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>estrategia.ases@correounivalle.edu.co</p>
        <p>
          Bajos de Biblioteca Mario Carvajal / Ciudad Universitaria Meléndez /
          Universidad del Valle Cali, Colombia
        </p>
      </div>
    </footer>
  );
};

export default Footer;
